<template>
    <div class="row voffset2">
        <div class="well well-lg" v-html="explanation"></div>
    </div>
</template>

<script>

export default {
  computed: {
  	explanation: function()	{
  		return this.$store.getters.currentStepExplanation;
  	}
  }
}
</script>
